module.exports = __webpack_public_path__ + "img/cyberboard_r2.86cc06f2.jpg";